import type { ReactNode } from 'react';

export interface DateDisplayProps {
  className?: string;
  children: ReactNode;
}

export const DateDisplay = ({
  className = undefined,
  children
}: DateDisplayProps) => {
  return (
    <div className={className} data-testid="date-display">
      {children}
    </div>
  );
};
